import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, Link } from "react-router-dom";

import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { Box, Container, Flex, HStack, Icon, Menu, MenuButton, MenuItem, MenuList, Select, Text } from "@chakra-ui/react";

import GrowthbookLayout from "@/components/layouts/GrowthbookLayout";
import growthbook from "@/utils/growthbook";

import SideNavBar from "../components/nav";
import ProfileBadge from "../components/nav/ProfileBadge";
import { signOutUser, updateOrgDetails } from "../store/slices/loginSlices";
import RouteSelector from "./RouteSelector";

const PageLayout = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const orgDetails = useSelector((state) => state?.login?.orgDetails);
  const midOrgs = useSelector((state) => state?.login?.midOrgs);
  const { orgName = "" } = useSelector((state) => state?.login?.orgDetails) || {};
  const companyName = orgName.charAt(0).toUpperCase() + orgName.slice(1);
  const [select, setSelect] = useState(false);
  const showMIDSelector = useMemo(() => {
    return midOrgs?.length > 1;
  }, [midOrgs?.length]);

  useEffect(() => {
    if (orgDetails) {
      growthbook.setAttributes({
        orgType: orgDetails.orgType,
        orgName: orgDetails.orgName,
        orgId: orgDetails.orgId,
        environment: import.meta.env.VITE_NODE_ENV,
      });
    }
  }, [orgDetails]);

  let canGoBack = false;
  let currHistoryIdx;
  if (typeof window !== "undefined") {
    currHistoryIdx = window?.history?.state?.idx || 0;
    canGoBack =
      location.pathname !== "/" &&
      location.pathname !== "/dashboard" &&
      location.pathname !== "/payin" &&
      location.pathname !== "/payout" &&
      location.pathname !== "/recipients" &&
      location.pathname !== "/order" &&
      location.pathname !== "/transactions" &&
      location.pathname !== "/help" &&
      location.pathname !== "/payin/payment-status" &&
      location.pathname !== "/payin/payment-summary" &&
      currHistoryIdx != 0;
  }

  const signOutAccount = useCallback(() => {
    dispatch(signOutUser());
  }, [dispatch]);

  return (
    <div style={{ position: "relative" }}>
      <Flex
        alignItems={"center"}
        height={"68px"}
        // justifyContent={"flex-end"}
        p="22px"
        borderBottom={"1px"}
        borderBottomColor={"#E4E4E4"}
        position={"sticky"}
        top={0}
        zIndex={"100"}
        bg={"#FFFFFF"}
      >
        <Flex flex flexGrow={1} alignItems={"center"} gap={4}>
          {showMIDSelector && (
            <>
              Select MID:
              <Select
                value={orgDetails?.orgId}
                width="20rem"
                height="40px"
                fontSize="14px"
                fontWeight="400"
                borderRadius="6px"
                borderColor="#E4E4E4"
                _focus={{ borderColor: "#1A4FD6" }}
                isClearable={true}
                onChange={(e) => {
                  const selectedMid = midOrgs?.find((mid) => mid?.orgId === e.target.value);
                  if (selectedMid) {
                    dispatch(updateOrgDetails(selectedMid));
                  }
                }}
              >
                {midOrgs?.map((mid, i) => (
                  <option key={i} value={mid?.orgId}>
                    {mid?.name} - {mid?.mid}
                  </option>
                ))}
              </Select>
            </>
          )}
        </Flex>
        {/* <Box>
                    <HStack>
                        {canGoBack ? (
                            <Icon
                                as={IoMdArrowBack}
                                width={"24px"}
                                height={"24px"}
                                onClick={() => navigate(-1)}
                                cursor="pointer"
                            />
                        ) : null}
                        <Heading as="h4" size="md">
                            {props?.title}
                        </Heading>
                    </HStack>
                </Box> */}
        {/* <Icon as={IoIosNotificationsOutline} width={"24px"} height={"24px"} /> */}
        <Flex gap={8} alignItems={"center"}>
          <Flex justify={"center"} alignItems={"center"} p={"10px"} rounded={"6px"} _hover={{ bg: select ? "" : "#F2F2F2" }} w={"153px"} h={"56px"}>
            <Menu>
              <MenuButton onClick={() => setSelect(!select)}>
                <HStack>
                  <ProfileBadge />
                  <Flex direction={"column"} alignItems={"start"}>
                    <Text>{userDetails?.firstName || (userDetails?.name && userDetails?.name?.split(" ")[0]) || ""}</Text>
                    {userDetails?.cxRoles?.map((role, i) => (
                      <Text key={i} color={"#B3B3B3"} fontSize={"12px"} fontWeight={"400"}>
                        {role}
                      </Text>
                    ))}
                  </Flex>
                  {select ? (
                    <Icon width={"20px"} height={"20px"} as={ChevronUpIcon} color={"#1A4FD6"} />
                  ) : (
                    <Icon width={"20px"} height={"20px"} as={ChevronDownIcon} color={"#1A4FD6"} />
                  )}
                </HStack>
              </MenuButton>
              <MenuList w={"200px"} p={"0"} boxShadow="md" borderRadius="md">
                <Flex alignItems={"center"} h={"40px"} bg={"#F7F9FC"} borderTopRadius="md">
                  <Text ml={"16px"} fontSize={"14px"} fontWeight={"500"} color={"#718096"}>
                    {companyName}
                  </Text>
                </Flex>
                <Link to="/settings">
                  <MenuItem
                    h={"45px"}
                    borderBottom={"1px"}
                    borderBottomColor={"#EDF2F7"}
                    textColor={"#4A5568"}
                    _hover={{ bg: "#F7FAFC" }}
                    fontSize="14px"
                    fontWeight="500"
                    px="16px"
                  >
                    Settings
                  </MenuItem>
                </Link>
                <MenuItem
                  h={"45px"}
                  onClick={signOutAccount}
                  color={"#3182CE"}
                  fontWeight={"500"}
                  _hover={{ bg: "#F7FAFC" }}
                  fontSize="14px"
                  px="16px"
                  borderBottomRadius="md"
                >
                  Log out
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>
      </Flex>
      <Flex height={"full"} align={{ base: "flex-start", md: "center" }}>
        <Container
          p="0"
          maxW={{ base: "100%" }}
          minH={{ base: "100%", md: "max(90vh);" }}
          height="auto"
          borderRadius={{ base: "none", md: "sm" }}
          display="flex"
          flexDirection="column"
          position="relative"
        >
          {props.children}
        </Container>
      </Flex>
    </div>
  );
};

export default function AuthorizedRoutes(props) {
  return (
    <GrowthbookLayout>
      <SideNavBar />
      <RouteSelector PageLayout={PageLayout} />
    </GrowthbookLayout>
  );
}
